import { useEffect } from 'react';

/**
 * Maakt het kopiëren/slepen/rechtsklikken op rasterafbeeldingen lastiger.
 * Geen echte beveiliging: schermfoto's en DevTools blijven mogelijk.
 * Uitzondering: zet `data-allow-image-context` op een ouder-element om rechtsklik op die boom toe te staan.
 */
function targetImg(el: EventTarget | null): HTMLImageElement | null {
  if (!(el instanceof Element)) return null;
  const img = el.closest('img');
  if (!img) return null;
  if (img.closest('[data-allow-image-context]')) return null;
  return img;
}

export function ImageCopyProtection() {
  useEffect(() => {
    const onContextMenu = (e: MouseEvent) => {
      if (targetImg(e.target)) e.preventDefault();
    };
    const onDragStart = (e: DragEvent) => {
      if (e.target instanceof HTMLImageElement && !e.target.closest('[data-allow-image-context]')) {
        e.preventDefault();
      }
    };
    const onAuxClick = (e: MouseEvent) => {
      if (e.button === 1 && targetImg(e.target)) e.preventDefault();
    };
    const onSelectStart = (e: Event) => {
      if (targetImg(e.target)) e.preventDefault();
    };

    document.addEventListener('contextmenu', onContextMenu, true);
    document.addEventListener('dragstart', onDragStart, true);
    document.addEventListener('auxclick', onAuxClick, true);
    document.addEventListener('selectstart', onSelectStart, true);

    return () => {
      document.removeEventListener('contextmenu', onContextMenu, true);
      document.removeEventListener('dragstart', onDragStart, true);
      document.removeEventListener('auxclick', onAuxClick, true);
      document.removeEventListener('selectstart', onSelectStart, true);
    };
  }, []);

  return null;
}
